import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "py-10 flex justify-between" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "text-3xl font-bold" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "border border-next-neu rounded text-center text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfermaModal = _resolveComponent("ConfermaModal")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_HomeAlertBar = _resolveComponent("HomeAlertBar")!
  const _component_TableTooltip = _resolveComponent("TableTooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TabellaContextMenu = _resolveComponent("TabellaContextMenu")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      (_ctx.confirmDelete)
        ? (_openBlock(), _createBlock(_component_ConfermaModal, {
            key: 0,
            backdrop: false,
            visible: _ctx.confirmDelete,
            onReject: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmDelete = false)),
            onConfirm: _ctx.performDelete
          }, null, 8, ["visible", "onConfirm"]))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Breadcrumbs, { paths: _ctx.getBreadcrumbsPath }, null, 8, ["paths"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_NextButton, {
              variant: "outline-secondary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back())),
              class: "w-48 hidden text-sm sm:block py-2 px-4"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" < Indietro ")
              ])),
              _: 1
            }),
            _createVNode(_component_NextButton, {
              component: "router-link",
              to: {name: 'NuovoCliente'},
              variant: "primary",
              class: "w-44 ml-3 text-sm py-2 px-4 m-0"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" + Aggiungi ")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.ETabTitle[_ctx.filterState] || _ctx.ETabTitle[0]), 1),
        _createVNode(_component_HomeAlertBar, {
          ok: _ctx.alert_counters.ok,
          scaduti: _ctx.alert_counters.scaduti,
          in_scadenza: _ctx.alert_counters.in_scadenza,
          contatti: _ctx.alert_counters.contatti,
          clienti: _ctx.alert_counters.clienti,
          active: _ctx.filterState
        }, null, 8, ["ok", "scaduti", "in_scadenza", "contatti", "clienti", "active"]),
        _createVNode(_component_NextTable, {
          class: "w-full table-fixed border-separate border-spacing-3 py-4",
          cols: _ctx.cols,
          rows: _ctx.lista.rows,
          onOrderUpdate: _ctx.lista.updateCols
        }, _createSlots({ _: 2 }, [
          _renderList(_ctx.lista.rows, (c, j) => {
            return {
              name: `td_${j}_0`,
              fn: _withCtx(({context}) => [
                _createVNode(_component_TableTooltip, {
                  inner_class: context.cell.td_class
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(context.row[context.cell.prop]), 1)
                  ]),
                  _: 2
                }, 1032, ["inner_class"])
              ])
            }
          }),
          _renderList(_ctx.lista.rows, (c, j) => {
            return {
              name: `td_${j}_1`,
              fn: _withCtx(({context}) => [
                _createVNode(_component_TableTooltip, {
                  inner_class: context.cell.td_class
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(context.row[context.cell.prop]), 1)
                  ]),
                  _: 2
                }, 1032, ["inner_class"])
              ])
            }
          }),
          _renderList(_ctx.lista.rows, (c, j) => {
            return {
              name: `td_${j}_4`,
              fn: _withCtx((context) => [
                _createVNode(_component_router_link, {
                  to: {name:'DettaglioAzienda', params:{id:context.context.row.id}},
                  class: "block text-center inset-0 absolute flex items-center justify-center"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                  ])),
                  _: 2
                }, 1032, ["to"])
              ])
            }
          }),
          _renderList(_ctx.lista.rows, (c, j) => {
            return {
              name: `td_${j}_5`,
              fn: _withCtx((context) => [
                _createVNode(_component_TabellaContextMenu, {
                  menuClass: "shadow absolute pr-10 flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white",
                  buttonClass: "bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange",
                  context: c,
                  id: j,
                  teleport_to: "#modal",
                  cmOpener: _ctx.cmOpener
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: {name:'Attivita', params: {id:c.id}},
                      class: "hover:text-next-neu mb-2"
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode(" Attività ")
                      ])),
                      _: 2
                    }, 1032, ["to"]),
                    _createVNode(_component_router_link, {
                      to: {name:'Contatti', params: {id:c.id}},
                      class: "hover:text-next-neu mb-2"
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode(" Contatti ")
                      ])),
                      _: 2
                    }, 1032, ["to"]),
                    _createElementVNode("span", {
                      onClick: ($event: any) => (_ctx.cancellaAzienda(c.id)),
                      class: "text-next-orange"
                    }, "Elimina", 8, _hoisted_6)
                  ]),
                  _: 2
                }, 1032, ["context", "id", "cmOpener"])
              ])
            }
          }),
          _renderList(_ctx.lista.rows, (c, j) => {
            return {
              name: `td_${j}_3`,
              fn: _withCtx((context) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.created_at)), 1)
              ])
            }
          }),
          _renderList(_ctx.lista.rows, (c, j) => {
            return {
              name: `td_${j}_2`,
              fn: _withCtx(({context}) => [
                _createElementVNode("div", {
                  class: "grid gap-1",
                  style: _normalizeStyle({'grid-template-columns': `repeat(${_ctx.businessUnits.length}, minmax(0, 1fr))`})
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessUnits, (bu) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "",
                      key: bu.id
                    }, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(bu.label), 1),
                      _createElementVNode("div", {
                        class: _normalizeClass([`bg-next-${_ctx.getColoriStati(context.row.stati[bu.id])}`, "border rounded text-center text-xs text-white"])
                      }, _toDisplayString(_ctx.getLabel(context.row.stati[bu.id])), 3)
                    ]))
                  }), 128))
                ], 4)
              ])
            }
          })
        ]), 1032, ["cols", "rows", "onOrderUpdate"]),
        _createVNode(_component_InfiniteLoading, {
          onInfinite: _ctx.lista.fetchNextPage,
          identifier: _ctx.lista.infiniteIdentifier,
          style: {"min-height":"1px"}
        }, {
          complete: _withCtx(() => _cache[7] || (_cache[7] = [
            _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri clienti.", -1)
          ])),
          _: 1
        }, 8, ["onInfinite", "identifier"])
      ])
    ])
  ], 64))
}